import * as types from "./types";
import INITIAL_STATE from "./init";

// style guide: avoid destructuring state

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADD_OPTION: {
      const {
        questionId,
        optionId,
        feedbackOptionId,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options;
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: { telemetry, feedbackOptionId },
            },
          },
        },
      };
    }
    case types.REMOVE_OPTION: {
      const { questionId, optionId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = { ...question.options };
      delete options[optionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: { ...question, options },
        },
      };
    }
    case types.SET_OPTION: {
      const {
        questionId,
        optionId,
        feedbackOptionId,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: { [optionId]: { telemetry, feedbackOptionId } },
          },
        },
      };
    }

    case types.ADD_SUB_OPTION: {
      const {
        questionId,
        optionId,
        subOptionId,
        feedbackOptionId,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions;
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: { telemetry, feedbackOptionId },
                },
              },
            },
          },
        },
      };
    }
    case types.REMOVE_SUB_OPTION: {
      const { questionId, optionId, subOptionId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = { ...option.subOptions } || {};
      delete subOptions[subOptionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions,
              },
            },
          },
        },
      };
    }
    case types.SET_SUB_OPTION: {
      const {
        questionId,
        optionId,
        subOptionId,
        feedbackOptionId,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: { [subOptionId]: { telemetry, feedbackOptionId } },
              },
            },
          },
        },
      };
    }

    case types.SET_OPTION_OTHER_TEXT: {
      const {
        questionId,
        optionId,
        feedbackOptionId,
        other_text,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                telemetry,
                feedbackOptionId,
                other_text,
              },
            },
          },
        },
      };
    }
    case types.SET_SUB_OPTION_OTHER_TEXT: {
      const {
        questionId,
        optionId,
        subOptionId,
        feedbackOptionId,
        other_text,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions || {};
      const subOption = subOptions[subOptionId];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: {
                    ...subOption,
                    telemetry,
                    feedbackOptionId,
                    other_text,
                  },
                },
              },
            },
          },
        },
      };
    }

    case types.ADD_OPTION_FILE: {
      const {
        questionId,
        optionId,
        feedbackOptionId,
        id,
        uri,
        type,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const files = option.files || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                telemetry,
                feedbackOptionId,
                files: [...files, { id, uri, type }],
              },
            },
          },
        },
      };
    }

    case types.REMOVE_OPTION_FILE: {
      const { questionId, optionId, id, telemetry } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const files = option.files || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                telemetry,
                files: files.filter(file => file.id !== id),
              },
            },
          },
        },
      };
    }

    case types.ADD_SUB_OPTION_FILE: {
      const {
        questionId,
        optionId,
        subOptionId,
        feedbackOptionId,
        id,
        uri,
        type,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions || {};
      const subOption = subOptions[subOptionId];
      const files = subOption.files || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: {
                    ...subOption,
                    telemetry,
                    feedbackOptionId,
                    files: [...files, { id, uri, type }],
                  },
                },
              },
            },
          },
        },
      };
    }

    case types.REMOVE_SUB_OPTION_FILE: {
      const {
        questionId,
        optionId,
        subOptionId,
        id,
        telemetry,
      } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions || {};
      const subOption = subOptions[subOptionId];
      const files = subOption.files || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: {
                    ...subOption,
                    telemetry,
                    files: files.filter(file => file.id !== id),
                  },
                },
              },
            },
          },
        },
      };
    }

    case types.ADD_OPTION_ITEM: {
      const { questionId, optionId, itemId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId];
      const products = option.products || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                products: [...products, itemId],
              },
            },
          },
        },
      };
    }

    case types.REMOVE_OPTION_ITEM: {
      const { questionId, optionId, itemId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId];
      const products = option.products || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                products: products.filter(iId => iId !== itemId),
              },
            },
          },
        },
      };
    }
    case types.ADD_SUB_OPTION_ITEM: {
      const { questionId, optionId, subOptionId, itemId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions || {};
      const subOption = subOptions[subOptionId];
      const products = subOption.products || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: {
                    ...subOption,
                    products: [...products, itemId],
                  },
                },
              },
            },
          },
        },
      };
    }

    case types.REMOVE_SUB_OPTION_ITEM: {
      const { questionId, optionId, subOptionId, itemId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = options[optionId] || {};
      const subOptions = option.subOptions || {};
      const subOption = subOptions[subOptionId];
      const products = subOption.products || [];
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: {
                ...option,
                subOptions: {
                  ...subOptions,
                  [subOptionId]: {
                    ...subOption,
                    products: products.filter(iId => iId !== itemId),
                  },
                },
              },
            },
          },
        },
      };
    }

    case types.VALIDATE_SECTION: {
      return {
        ...state,
        canMoveForward: action.payload.isValid,
      };
    }

    case types.CLEAR_QUESTION: {
      const questions = { ...state.questions };
      delete questions[action.payload.questionId];
      return {
        ...state,
        questions,
      };
    }

    case types.CLEAR_SUB_OPTIONS: {
      const { questionId, optionId } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      const options = question.options || {};
      const option = { ...options[optionId] };
      delete option.subOptions;
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            options: {
              ...options,
              [optionId]: option,
            },
          },
        },
      };
    }

    case types.SET_QUESTION_SCORE: {
      const { questionId, score } = action.payload;
      const questions = state.questions;
      const question = questions[questionId] || {};
      return {
        ...state,
        questions: {
          ...questions,
          [questionId]: {
            ...question,
            score,
          },
        },
      };
    }

    case types.SET_LANGUAGE_KEY:
      return {
        ...state,
        lang: action.payload.langKey,
        headingKey: action.payload.headingKey,
      };

    case types.SHOW_MODAL:
      return { ...state, modal: { message: action.payload, visible: true } };

    case types.HIDE_MODAL:
      return { ...state, modal: { ...state.modal, visible: false } };

    case types.SET_OPTION_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload]: true } };

    case types.CLEAR_OPTION_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload]: false } };

    default:
      return state;
  }
};
